import React, {
  useCallback,
  useEffect,
  useState,
  useMemo,
  useRef,
  useForm,
} from "react";
import {
  Button,
} from "antd";
import { useHistory } from "react-router-dom";
import "./index.scss";
import one from "../../images/home/one.png";
import two from "../../images/home/two.png";
import three from "../../images/home/three.png";

export default function JobCollection(props) {

  const [defaultValues, setDefaultValues] = useState("");
  const [currentCityTwo, setCurrentCityTwo] = useState("创业帮扶列表");

  const history = useHistory();

  const helpClick = (key) => {
    switch (key) {
      case 1:
        history.push('/entrance/assistanceFinance')
        // handleChangeCity(4, "创业金融服务");
        break;
      case 2:
        history.push('/entrance/assistanceExpert')
        // handleChangeCity(3, "创业专家");
        break;
      case 3:
        history.push("/entrance/policy/2");
        break;

      default:
        break;
    }
  };

  return (
    console.log("defaultValues", defaultValues),
    (
      <div className={"createAssist_app"}>
        <div
          className={"getjob_Search"}
          style={{ padding: "16px 0", background: "#FBFBFB", minHeight: 400 }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <span>当前位置：创业帮扶 / </span>
              <span style={{ color: "#1890ff", cursor: "pointer" }}>
                {" "}
                {currentCityTwo}
              </span>
            </div>
          </div>

          <div className="helpBox" style={{marginTop: 15}}>
            {/* <div className="title">
              <h2>创业帮扶</h2>
            </div> */}
            <div className="helpBoxList">
              <div
                className="oneHelpBox"
                onClick={() => {
                  helpClick(1);
                }}
              >
                <span className="helpName">创业金融服务</span>
                <Button shape="round" className="helpButton">
                  查看详情
                </Button>
                <img src={one} alt="" />
              </div>
              <div
                className="oneHelpBox"
                onClick={() => {
                  helpClick(2);
                }}
              >
                <span className="helpName">创业服务支持</span>
                <Button shape="round" className="helpButton">
                  查看详情
                </Button>
                <img src={two} alt="" />
              </div>
              <div
                className="oneHelpBox"
                onClick={() => {
                  helpClick(3);
                }}
              >
                <span className="helpName">创业优惠政策</span>
                <Button shape="round" className="helpButton">
                  查看详情
                </Button>
                <img src={three} alt="" />
              </div>
            </div>
          </div>

        </div>

      </div>
    )
  );
}
